export default __webpack_public_path__ + "static/tautopoihsh_fysikwn_prosopwn-498c6355fcac416af2cfe46ddeae63bd.pdf";